import React from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../../../layout/Footer";
import Header from "../../../layout/Header";
import HeroSection from "../../../layout/HeroSection";
import { pageRoutes } from "../../../routes/pageRoutes";

const CheckoutToPay = () => {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <HeroSection label={<h1 class="mb-3">{"Checkout"}</h1>} />
      <div class="untree_co-section pt-5">
        <div class="container">
          <div class="row">
            <div class="col-md-6 mb-5 mb-md-0">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <h2 class="h3 mb-4 text-black">Billing Details</h2>
                <div class="mb-3"></div>
              </div>
              <div class="p-3 p-lg-5 border ct_bg_grey">
                <div class="form-group row">
                  <div class="col-md-12 mb-3">
                    <label for="c_fname" class="text-black mb-1">
                      Full Name <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_fname"
                      name="name"
                      placeholder="Enter full name"
                      value="Noble Beasley"
                    />
                  </div>
                </div>
                <div class="form-group row mb-4">
                  <div class="col-md-6">
                    <label for="c_email_address" class="text-black">
                      Email Address <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_email_address"
                      name="email"
                      placeholder="Enter email address"
                      value="nycenewy@mailinator.com"
                    />
                  </div>
                  <div class="col-md-6">
                    <label for="c_phone" class="text-black">
                      Number <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_phone"
                      name="number"
                      placeholder="Phone Number"
                      value="+1 (304) 854-8892"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-6 form-group mb-3">
                    <label for="c_country" class="text-black mb-1">
                      Country <span class="text-danger">*</span>
                    </label>
                    <select className="form-control">
                      <option>India</option>
                      <option>China</option>
                    </select>
                  </div>
                  <div class="col-md-6 mb-3">
                    <label for="c_state_country" class="text-black mb-1">
                      State <span class="text-danger">*</span>
                    </label>
                    <select className="form-control">
                      <option>India</option>
                      <option>China</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12 mb-3">
                    <label for="c_company_name" class="text-black mb-1">
                      Company Name{" "}
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_company_name"
                      name="company_name"
                      placeholder="Enter company name"
                      value="Kinney Little Trading"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12 mb-3">
                    <label for="address_line_1" class="text-black mb-1">
                      Address Line 1 <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="address_line_1"
                      name="address_line_1"
                      placeholder="Enter address"
                      value="77 East Green New Parkway"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12 mb-3">
                    <label for="address_line_2" class="text-black mb-1">
                      Address Line 2
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="address_line_2"
                      name="address_line_2"
                      placeholder="Enter address"
                      value="Dolores vel incidunt"
                    />
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12 mb-3">
                    <label for="c_postal_zip" class="text-black">
                      Postal / Zip <span class="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="c_postal_zip"
                      name="postal_code"
                      placeholder="Enter postal / zip"
                      value="76489"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="c_order_notes" class="text-black">
                    Order Notes
                  </label>
                  <textarea
                    class="form-control"
                    id="c_order_notes"
                    name="other_notes"
                    placeholder="Enter any additional notes"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row mb-5">
                <div class="col-md-12">
                  <h2 class="h3 mb-4 text-black">Your Order</h2>
                  <div class="p-3 p-lg-5 border ct_bg_grey">
                    <table class="table site-block-order-table mb-5 ct_checkout_cart_main">
                      <thead>
                        <th>Plan</th>
                        <th>Total</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="text-black font-weight-bold">{`<Plan Name>`}</td>
                          <td class="text-black"> $0.00</td>
                        </tr>

                        <tr>
                          <td class="text-black font-weight-bold">
                            <strong>Total</strong>
                          </td>
                          <td class="text-black font-weight-bold">
                            <strong> $0.00</strong>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div>
                      <h6 class="text-dark  mb-3">Select Payment Method</h6>
                      <div class="border p-3 mb-3">
                        <label class="h6 mb-0" for="debit_card">
                          <a class="d-block">
                            <input
                              name="card"
                              type="radio"
                              class="me-1"
                              id="debit_card"
                              value="Debit Card"
                            />
                            Debit Card
                          </a>
                        </label>
                      </div>
                      <div class="border p-3 mb-3">
                        <label class="h6 mb-0" for="credit_card">
                          <a class="d-block">
                            <input
                              type="radio"
                              name="card"
                              id="credit_card"
                              class="me-1"
                              value="Credit Card"
                            />
                            Credit Card
                          </a>
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-secondary ct_btn_animate w-100"
                      >
                        Place Order
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CheckoutToPay;
